window.addEventListener("load", function () {
    const texts = ['Toái Mộng', 'Cửu Linh', 'Tố Vấn', 'Thần Tương', 'Huyết Hà', 'Thiết Y'];
    var swiper, swiper2;

    if ($('body').data('device-type') === 'desktop') {
        // Desktop: Chỉ khởi tạo swiper chính, không cần mySwiper2
        $('.swiper-swiper .swiper-slide').each(function(index) {
            $(this).addClass(`stt-${index + 1}`);
        });
        
        swiper = new Swiper(".swiper-swiper", {
            effect: "fade",
            loop: true,
            touchRatio: 0,
            pagination: {
                el: ".swiper-swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    const text = texts[index] || '•';
                    return `<span class="pagi-dot stt-${index + 1} ${className}">${text}</span>`;
                },
            },
        });
    } else {
        // Mobile: Thay thế HTML swiper-swiper và thêm touch events
        const swiperContainer = $('.swiper-swiper');
        
        // Tạo HTML mới cho mobile - chỉ hiển thị slide đầu tiên
        const baseUrl = 'https://global-mainsite.mto.zing.vn/products/nghichthuyhan/mainsite/dist/assets/nth-ms-swiper/images/';
        const newHTML = `
            <div class="mobile-swiper-content stt-1">
                <div class="background">
                    <img src="${baseUrl}bg-1.jpg" class="MS__pc " />
                    <img src="${baseUrl}char-1.png" class="MS__mb " />
                </div>
                <div class="content">
                    <img src="${baseUrl}text-1.png" class="effect text " />
                    <a href="https://youtu.be/qWfkfUMpcng" class="effect btn-video MS__hover" data-fancybox></a>
                </div>
            </div>
        `;
        
        // Thay thế nội dung
        swiperContainer.html(newHTML);

        // Khởi tạo mySwiper2 chỉ cho mobile
        swiper2 = new Swiper(".mySwiper2", {
            slidesPerView: 5,
            touchRatio: 0,
            loop: false,
            centeredSlides: true,
            slideToClickedSlide: true,
        });

        // Logic cho mobile: Khi click vào mySwiper2
        const links = [
            'https://youtu.be/qWfkfUMpcng',
            'https://youtu.be/-uNvx2Wdxyk',
            'https://youtu.be/O5V5B3oHWUo',
            'https://youtu.be/nwgdBhQmztQ',
            'https://youtu.be/VhALnJSU7lg',
            'https://youtu.be/wQEgCHRGWAM'
        ];

        let currentIndex = 0;
        let startX = 0;
        let endX = 0;

        // Thêm touch events cho mobile-swiper-content
        const mobileContent = $('.mobile-swiper-content');
        
        mobileContent.on('touchstart', function(e) {
            startX = e.originalEvent.touches[0].clientX;
        });

        mobileContent.on('touchend', function(e) {
            endX = e.originalEvent.changedTouches[0].clientX;
            handleSwipe();
        });

        function handleSwipe() {
            const swipeThreshold = 50; // Ngưỡng vuốt tối thiểu
            const diffX = startX - endX;

            if (Math.abs(diffX) > swipeThreshold) {
                if (diffX > 0) {
                    // Vuốt trái -> next
                    currentIndex = (currentIndex + 1) % 6;
                } else {
                    // Vuốt phải -> prev
                    currentIndex = (currentIndex - 1 + 6) % 6;
                }
                
                updateContent(currentIndex);
                swiper2.slideTo(currentIndex);
            }
        }

        function updateContent(index) {
            const mobileContent = $('.mobile-swiper-content');
            
            // Xóa tất cả class stt- cũ và thêm class stt- mới
            mobileContent.removeClass('stt-1 stt-2 stt-3 stt-4 stt-5 stt-6').addClass(`stt-${index + 1}`);
            
            // Cập nhật background
            mobileContent.find('.background .MS__pc').attr('src', `${baseUrl}bg-${index + 1}.jpg`);
            mobileContent.find('.background .MS__mb').attr('src', `${baseUrl}char-${index + 1}.png`);
            
            // Cập nhật content
            mobileContent.find('.content .text').attr('src', `${baseUrl}text-${index + 1}.png`);
            mobileContent.find('.content .btn-video').attr('href', links[index]);
        }

        swiper2.on('click', function () {
            if (swiper2.clickedSlide) {
                currentIndex = swiper2.realIndex;
                updateContent(currentIndex);
            }
        });

        // Thêm class stt- cho mySwiper2 slides
        $('.mySwiper2 .swiper-slide').each(function(index) {
            $(this).addClass(`stt-${index + 1}`);
        });
    }
});
